import botErrorStore from '../../store/BotErrorStore';
import { WEvent } from './WEvent';

export class WBotErrorEvent extends WEvent {
  id: string;

  pid: string;
  nick: string;
  myBot: boolean;

  country: string;

  errorMessage: string;

  constructor(event: WBotErrorEvent) {
    super(event.tableId, event.eventType, event.eventTime);
    Object.assign(this, event);
  }

  applyWebsocketChanges = (): Promise<void> => {
    botErrorStore.addBotError({ ...this });
    return Promise.resolve();
  };
}
